import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
const PublicRoute = ({ component: RouteComponent }) => {
    return _jsx(_Fragment, { children: RouteComponent != null ? _jsx(RouteComponent, {}) : _jsx(Outlet, {}) });
};
export default PublicRoute;
